import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiClientService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = environment.apiBaseUrl;

  get<TData>(path: string): Observable<ApiResponse<TData>> {
    return this.http.get<ApiResponse<TData>>(this.buildUrl(path));
  }

  getRaw<TResponse>(path: string): Observable<TResponse> {
    return this.http.get<TResponse>(this.buildUrl(path));
  }

  postRaw<TResponse, TBody>(path: string, body: TBody): Observable<TResponse> {
    return this.http.post<TResponse>(this.buildUrl(path), body);
  }

  putRaw<TResponse, TBody>(path: string, body: TBody): Observable<TResponse> {
    return this.http.put<TResponse>(this.buildUrl(path), body);
  }

  patchRaw<TResponse, TBody>(path: string, body: TBody): Observable<TResponse> {
    return this.http.patch<TResponse>(this.buildUrl(path), body);
  }

  deleteRaw<TResponse>(path: string): Observable<TResponse> {
    return this.http.delete<TResponse>(this.buildUrl(path));
  }

  private buildUrl(path: string): string {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${this.apiBaseUrl}${normalizedPath}`;
  }
}
